import React, { useState } from "react";

const ASSET_BASE_URL = process.env.REACT_APP_ASSET_BASE_URL || "https://api.passionateworlduniversity.com/api";

const BlogDetailsContent = ({ data }) => {
  const [showVideo, setShowVideo] = useState(false);

  if (!data) return <p>No content available</p>;

  const addAutoplay = (url) => {
    if (!url) return url;
    return url.includes("?") ? `${url}&autoplay=1` : `${url}?autoplay=1`;
  };

  return (
    <div className="blog-details">
      {/* Title */}
      <h2 className="title" style={{ fontSize: "32px", fontWeight: "bold", marginBottom: "10px" }}>
        {data.title}
      </h2>

      {/* Meta Info */}
      <div className="blog-meta" style={{ marginBottom: "20px", color: "#666", fontSize: "14px" }}>
        <span>
          <strong>Date:</strong> {data.date}
        </span>
        <span style={{ marginLeft: "20px" }}>
          <strong>Author:</strong> {data.text || "Unknown"}
        </span>
      </div>

      {/* Thumbnail container */}
      {data.image && (
        <div
          className="blog-thumbnail"
          style={{
            position: "relative",
            cursor: data.video_url ? "pointer" : "default",
            maxHeight: "400px",
            borderRadius: "10px",
            overflow: "hidden",
            marginBottom: "30px",
          }}
          onClick={() => data.video_url && setShowVideo(true)}
        >
          {/* Show either the thumbnail image OR the video */}
          {!showVideo ? (
            <>
              <img
                src={`${ASSET_BASE_URL}/storage/${data.image}`}
                alt={data.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: "10px",
                }}
              />
              {/* Play Button Overlay */}
              {data.video_url && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    background:
                      "linear-gradient(95deg, rgb(5, 157, 255) 15%, rgb(101, 73, 213) 45%, rgb(227, 63, 161) 75%, rgb(251, 83, 67) 100%)",
                    borderRadius: "50%",
                    width: "70px",
                    height: "70px",
                    color: "#fff",
                    fontSize: "30px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pointerEvents: "none",
                    userSelect: "none",
                  }}
                >
                  ▶
                </div>
              )}
            </>
          ) : (
            <iframe
              width="100%"
              height="400"
              src={addAutoplay(data.video_url)}
              title={data.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: "10px", display: "block" }}
            />
          )}
          {/* Close button shown only when video is playing */}
          {showVideo && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowVideo(false);
              }}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0,0,0,0.6)",
                border: "none",
                borderRadius: "50%",
                color: "#fff",
                width: "30px",
                height: "30px",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: 10,
              }}
              aria-label="Close Video"
            >
              ✕
            </button>
          )}
        </div>
      )}

      {/* Body */}
      <div className="blog-body" style={{ fontSize: "16px", lineHeight: "1.7", color: "#333" }}>
        {Array.isArray(data.body) &&
          data.body.map((item, index) => (
            <p key={index} style={{ marginBottom: "20px" }}>
              {item.value}
            </p>
          ))}
      </div>

      {/* Tags */}
      {data.tags && data.tags.length > 0 && (
        <div className="blog-tags mt--20" style={{ marginTop: "40px", fontSize: "14px", color: "#444" }}>
          <strong>Tags:</strong>{" "}
          {data.tags.map((tag, i) => (
            <span
              key={i}
              style={{ marginRight: "10px", backgroundColor: "#f0f0f0", padding: "4px 10px", borderRadius: "20px" }}
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogDetailsContent;
